import { gql } from '@provision/graphql-client';

export const GET_SUBSCRIPTIONS_REPORT_QUERY = gql`
  query GetSubscriptionsReport($params: GetSubscriptionsReportParams!) {
    getSubscriptionsReport(params: $params) {
      pagination {
        nextPage
        limit
        totalCount
      }
      records {
        addressId
        clientId
        address1
        address2
        businessName
        city
        state
        segment
        subscriptionId
        status
        canceledAt
        customerName
        customerEmail
        invoiceSubtotal
        createdAt
        currentPeriodStart
        currentPeriodEnd
        productName
        intervalCount
        interval
        latestInvoiceSubtotal
        latestInvoiceDiscount
        chargeAmount
        latestInvoiceUrl
      }
    }
  }
`;
